import React from 'react';
import { Grid, Box } from '@mui/material';
import PostCard from './PostCard';
import { useSelector } from 'react-redux';

const PostGrid = ({ posts, loading }) => {
  const savedPostsIds = useSelector((state) => state.user.userInfo.savedPosts || []);

  return (
    <Box sx={{ minHeight: '60vh' }}>
      <Grid container spacing={3}>
        {posts.map((post) => (
          <Grid item xs={12} sm={6} lg={4} key={post._id}>
            <PostCard 
              post={post} 
              isSaved={savedPostsIds.includes(post._id)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PostGrid;